import React from "react";
import { STATUS_MESSAGE_COLORS } from "../../config";

/**
 * StatusMessage Component
 * 
 * Displays status messages with appropriate styling based on message type.
 * 
 * Message types:
 * - error: Red background with dark red text
 * - warning: Orange background with dark orange text
 * - info: Yellow background with dark yellow text
 * - success: Green background with dark green text
 * 
 * @param {Object} props
 * @param {Object|null} props.message - Message object with type and text properties, or null to display nothing
 * @param {string} props.message.type - Type of message ("error", "warning", "info", or "success")
 * @param {string} props.message.text - Message text content
 * @param {string} [props.className] - Additional CSS classes to apply to the component
 * @returns {JSX.Element|null} The message component or null if no message provided
 */
const StatusMessage = ({ message, className = "" }) => {
  if (!message) return null;

  /**
   * Maps the message type to a Tailwind color class string.
   *
   * @returns {string} Background/text color classes.
   */
  const getTypeStyles = () => {
    return STATUS_MESSAGE_COLORS[message.type] || STATUS_MESSAGE_COLORS.success;
  };

  return (
    <div className={`p-3 rounded ${getTypeStyles()} ${className}`}>
      {message.text}
    </div>
  );
};

export default StatusMessage;
